"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotCalendarCheckMark = void 0;
var _SVG = require("../SVG");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SpotCalendarCheckMark = _ref => {
  let {
    color = "#13126C",
    spotColor = "#E4EDFE",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#calendar_blue_check_mark_svg__a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: spotColor,
    fillRule: "evenodd",
    d: "M28.698 9.816c-2.536-2.053-6.625-5.269-11.804-5.894-5.187-.619-11.941 1.3-13.605 5.227C1.641 13.077.538 13.242.68 23.452c-.3 7.265.13 12.14 4.33 14.354 3.61 1.902 19.228-.243 23.547-2.25 4.325-1.998 7.457-4.296 9.364-7.127 1.915-2.822 2.11-5.512 1.213-8.049-.911-2.538-2.91-4.937-4.898-6.269-1.987-1.332-2.985-2.24-5.537-4.295Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: 28,
    height: 25.2,
    x: 6,
    y: 7.8,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2,
    rx: 2
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2,
    d: "M26.224 5v5.6M13.778 5v5.6M6 16.2h28M16 24.55l3.755 3.55L24.63 21"
  })));
};
exports.SpotCalendarCheckMark = SpotCalendarCheckMark;
SpotCalendarCheckMark.displayName = "SpotCalendarCheckMark";